// extracted by mini-css-extract-plugin
export default {"cls1":"Base-cls1___25f047635525e4f0db4","cls2":"Base-cls2___7e7ed49704370c87187 Base-cls1___25f047635525e4f0db4"};